import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Select from 'react-select'
import { createEntity } from '../../common/redux/collectionActions'

export default ({ lock, onChange }) => {
    const dispatch = useDispatch()

    const lockCompanies = lock.users.map(u => u.company)
    const companies = useSelector(state => state.collectionData.companies.companies.filter((c) => lockCompanies.includes(c._id)))

    const [selectedCompanies, setSelectedCompanies] = useState([])

    const createCompany = async (name) => {
        const { data } = await dispatch(createEntity('company', { name }))

        const createdCompany = data.find(d => d.name === name)

        setSelectedCompanies((selectedCompanies || []).concat({ label: createdCompany.name, value: createdCompany._id }))
    }

    useEffect(() => {
        onChange(selectedCompanies)
    }, [selectedCompanies])

    return (
        <Select
            noOptionsMessage={() => 'Tomt'}
            isMulti
            isClearable
            onChange={list => setSelectedCompanies(list || [])}
            value={selectedCompanies}
            options={companies.map(c => { return { label: c.name, value: c._id } })}
            placeholder="Företag, lämna tomt för alla"
        />
    )
}